import React, { useContext, useState } from "react";
import { ContentContext } from "../App";

const Hero = () => {
  const { content, loading } = useContext(ContentContext);
  const [contentLoaded, setContentLoaded] = useState(false);

  // Only show content when it's fully loaded
  React.useEffect(() => {
    if (content.hero_title) {
      setContentLoaded(true);
    }
  }, [content]);

  // Show placeholder with same height as final content to prevent layout shift
  if (loading || !contentLoaded) {
    return (
      <section id="inicio" className="bg-gradient-to-br from-purple-600 via-purple-700 to-yellow-400 text-white py-20">
        <div className="container mx-auto px-4 text-center">
          <div className="animate-pulse">
            <div className="h-12 sm:h-14 bg-white/20 rounded max-w-lg mx-auto mb-6"></div>
            <div className="h-6 bg-white/20 rounded max-w-md mx-auto mb-2"></div>
            <div className="h-6 bg-white/20 rounded max-w-xl mx-auto mb-8"></div>
            <div className="flex justify-center space-x-4">
              <div className="h-12 w-36 bg-white/30 rounded-lg"></div>
              <div className="h-12 w-28 bg-white/20 rounded-lg"></div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section id="inicio" className="bg-gradient-to-br from-purple-600 via-purple-700 to-yellow-400 text-white py-20">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-5xl font-bold mb-6">
          {content.hero_title}
        </h2>
        <p className="text-xl mb-2 font-semibold">
          {content.hero_subtitle}
        </p>
        <p className="text-lg mb-8 max-w-2xl mx-auto">
          {content.hero_description}
        </p>
        <div className="flex justify-center space-x-4">
          <button 
            onClick={() => document.getElementById('propiedades').scrollIntoView({ behavior: 'smooth' })}
            className="bg-white text-purple-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors"
          >
            Ver Propiedades
          </button>
          <button 
            onClick={() => document.getElementById('contacto').scrollIntoView({ behavior: 'smooth' })}
            className="border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white hover:text-purple-600 transition-colors"
          >
            Contactar
          </button>
        </div>
      </div>
    </section>
  );
};

export default Hero;